import React from 'react'
import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'
import { HouseConsignmentFormValues } from 'features/declaration/house-consignment/models/schema'
import useCodelist from 'features/declaration/codelist/api/useCodelist'
import { useCalculatorModal } from 'features/declaration/form/components/calculator/CalculatorModalContext'
import FormField from '../../../../../../components/p5/FormField'
import FormCollapsibleColumn from '../../../../../../components/p5/FormCollapsibleColumn'
import Input from '../../../../../../components/p5/Input'
import FormSelect from '../../../../../../components/p5/FormSelect'
import useDeclarationFieldRequirements
  from '../../../components/useDeclarationFieldRequirements'

function TransitHouseConsignmentInfo() {
  const { t } = useTranslation()
  const { setValue } = useFormContext<HouseConsignmentFormValues>()
  const [, countriesOptions] = useCodelist('COUNTRIES')
  const [, paymentMethodOptions] = useCodelist('PAYMENT_METHODS')
  const { open } = useCalculatorModal()

  const fieldRequirements = useDeclarationFieldRequirements<HouseConsignmentFormValues>('houseConsignment', [
    'countryOfDispatch',
    'countryOfDestination',
    'grossMass',
    'referenceNumberUCR',
    'transportChargesMethodOfPayment',
  ])

  return (
    <section className="py-3">
      <FormCollapsibleColumn
        columnId="declaration-house-consignment"
        headingLabel={t('declaration.p5.houseConsignment')}
      >
        <FormField
          labelKey="declaration.p5.referenceNumberUCR"
          fieldRule={fieldRequirements.referenceNumberUCR}
        >
          <Input
            field="referenceNumberUCR"
            labelKey="declaration.p5.referenceNumberUCR"
            type="text"
            placeholder={t('declaration.p5.referenceNumberUCR')}
            fieldRule={fieldRequirements.referenceNumberUCR}
          />
        </FormField>
        <FormField
          labelKey="declaration.p5.countryOfDispatch"
          fieldRule={fieldRequirements.countryOfDispatch}
        >
          <FormSelect
            field="countryOfDispatch"
            labelKey="declaration.p5.countryOfDispatch"
            options={countriesOptions}
            type="sync"
            fieldRule={fieldRequirements.countryOfDispatch}
          />
        </FormField>
        <FormField
          labelKey="declaration.p5.transportChargesMethodOfPayment"
          fieldRule={fieldRequirements.transportChargesMethodOfPayment}
        >
          <FormSelect
            field="transportChargesMethodOfPayment"
            labelKey="declaration.p5.transportChargesMethodOfPayment"
            options={paymentMethodOptions}
            type="sync"
            fieldRule={fieldRequirements.transportChargesMethodOfPayment}
          />
        </FormField>
        <FormField
          labelKey="declaration.p5.grossMass"
          fieldRule={fieldRequirements.grossMass}
        >
          <div className="input-group">
            <Input
              field="grossMass"
              labelKey="declaration.p5.grossMass"
              type="number"
              inputMode="decimal"
              step={0.001}
              placeholder={t('declaration.p5.grossWeight')}
              fieldRule={fieldRequirements.grossMass}
            />
            <div className="input-group-append">
              <button
                type="button"
                className="btn btn-light h-100 border fw-bold"
                onClick={() => {
                  open({
                    onResolve: (value: number) => {
                      setValue('grossMass', value)
                    },
                  })
                }}
              >
                <i className="fas fa-calculator" />
              </button>
            </div>
          </div>
        </FormField>
        <FormField
          labelKey="declaration.p5.countryOfDestination"
          fieldRule={fieldRequirements.countryOfDestination}
        >
          <FormSelect
            field="countryOfDestination"
            labelKey="declaration.p5.countryOfDestination"
            options={countriesOptions}
            type="sync"
            fieldRule={fieldRequirements.countryOfDestination}
          />
        </FormField>
      </FormCollapsibleColumn>
    </section>
  )
}

export default TransitHouseConsignmentInfo
